
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topics/[id]/[title]",
      function () {
        return require("private-next-pages/topics/[id]/[title].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topics/[id]/[title]"])
      });
    }
  